<div id="form-container">
    <form
            [formGroup]="form"
            id="main-form"
            data-testid="main-form"
            class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpb-8"
            (ngSubmit)="onSubmit()">
        <h3 class="ui-heading-3-bold">Milestone</h3>
        <form id="metadata" [formGroup]="form.controls.metadata">
            <h4 class="ui-heading-4--m">Metadata</h4>
            <rds-form-field labelPosition="side-left">
                <rds-control-label>Study</rds-control-label>
                <input
                        rdsInput
                        formControlName="projectName"
                        placeholder="Project Name"
                        data-testid="projectName"
                />
            </rds-form-field>
            <app-expandable-input [control]="form.controls.metadata.controls.studyDescription" label="Study Description" [data-testid]="'studyDescription'"></app-expandable-input>
            <rds-form-field labelPosition="side-left">
                <rds-control-label>Milestone</rds-control-label>
                <input
                        rdsInput
                        formControlName="activityName"
                        placeholder="Activity Name"
                        data-testid="activityName"
                />
            </rds-form-field>
            <rds-form-field labelPosition="side-left">
                <rds-control-label>Due Date</rds-control-label>
                <input
                        rdsInput
                        formControlName="date"
                        data-testid="date"
                />
            </rds-form-field>
        </form>
                <rds-divider></rds-divider>
                <!-- Unified Pillars & Audiences Section -->
                        <app-pillars-audiences-section
                            entityType="milestone"
                            [entityId]="milestone().abstractID"
                            [isViewer]="isViewer"
                            [initialPillars]="milestone().strategicPillars || []"
                            [initialAudiences]="milestone().audiences || []"
                            (pillarChanged)="onPillarChanged($event)"
                            (audienceChanged)="onAudienceSelectionChange($event)">
                        </app-pillars-audiences-section>
                <rds-divider></rds-divider>
        <div id="editable">
            <div id="custom-data">
                <h4 class="ui-heading-4--m">Custom Data</h4>
                <div class="rds-form-field">
                    <section class="list">
                        <p class="rds-form-field__label list-label">Keywords</p>
                        <div class="list-content">
                            @for(keyword of form.controls.keyWords.controls; track keyword){
                            <rds-form-field labelPosition="side-left">
                                <input rdsInput [formControl]="keyword" data-testid="keywords" (keypress)="onKeywordKeypress($event)"/>
                                <div class="d-flex align-items-center justify-content-end" [style.visibility]="editorActionsVisible">
                                    <button rds-control-suffix rds-icon-button (click)="removeKeyword($index)"
                                            size="s" class="ms-2" data-testid="keyword-remove">
                                        <rds-icon namespace="outlined" icon="close"/>
                                    </button>
                                </div>
                            </rds-form-field>
                            }
                        </div>
                    </section>
                    <button rds-text-button (click)="addKeyword()" class="ms-auto" type="button" data-testid="keyword-add"  [style.visibility]="editorActionsVisible">
                        <rds-icon namespace="filled" icon="plus"/>
                        Add Keyword
                    </button>
                </div>
                <rds-form-field labelPosition="side-left">
                    <rds-control-label>Link</rds-control-label>
                    <input
                            rdsInput
                            formControlName="link"
                            placeholder="Link"
                            data-testid="link"
                    />
                    @if(form.controls.link.value){
                        <div class="d-flex align-items-center justify-content-end">
                            <button rds-icon-button size="m" class="ms-2" type="button">
                                <rds-icon namespace="filled" icon="link" (click)="openLink()"></rds-icon>
                            </button>
                        </div>
                    }
                </rds-form-field>
              <app-expandable-input label="Notes" [control]="form.controls.notes" [data-testid]="'notes'"></app-expandable-input>

                        

            </div>
            @if(!isViewer){
                <rds-divider></rds-divider>
                <div id="editable">
                    <rds-switch formControlName="isVisible" labelPosition="before" [checked]="form.controls.isVisible">Visible for viewers?</rds-switch>
                </div>
            }

        </div>
        <button rds-primary-button class="ms-auto" type="submit" [disabled]="isLoadingChanges()" size="m" data-testid="submit"  [style.visibility]="editorActionsVisible">
          @if(!isLoadingChanges()){
            Save
          }
          @else{
            <rds-progress-spinner label="Updating..." size="m" ></rds-progress-spinner>
          }
        </button>
    </form>
</div>
